import { IDefineCommand } from 'core-ts-types';
import { MajorService } from './../services/major_service';

angular
  .module('major-explorer-data')
  .factory('loadMajorDetailCommand', (defineCommand: IDefineCommand, ngMajorService: MajorService) => {
    return defineCommand('loadMajorDetailCommand', (deferred: ng.IDeferred<any>, id: string) => {
      const currentMajor = ngMajorService.getMajor(parseInt(id, 10));
      deferred.resolve(currentMajor);
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/load_major_detail_command.ts